<div class="business">
  <div class="content">
    <div class="title">环球巴士成立于2019年7月</div>
    <div class="subtitle">全球优质互联网服务一站式合租平台</div>
    <div class="subtitle">
      我们主营会员合租、代充值和多项便捷服务，涉及影视、音乐、游戏、办公等领域。
    </div>
    <div class="parts">
      <div
        class="item"
        *ngFor="let item of list; let i = index"
        [routerLink]="item.link"
        (click)="open(i)"
      >
        <img [src]="item.icon" alt="" width="184" height="184" />
        <div class="text">{{ item.text }}</div>
      </div>
    </div>
  </div>
</div>
